module.exports = __webpack_public_path__ + "static/media/svg-placeholder.a6a2c99c.svg";